import { createHTTPClient } from "@airhelp/http-client";
import { caller, valid, queryStringAddon, snakeCaseBody } from "@airhelp/http-client/addons";
import { a, P, b } from "./types-CKJf4qjO.js";
import { j as journeySchema } from "./update-air-luggage-journeys-DAg_1mM1.js";
import { A, H, B, z, y, Q, C, T, ac, ab, I, J, D, E, F, G, w, M, L, R, af, ae, ad, a1, a0, a7, a6, a8, aa, a9, s, K, o, n, l, k, i, h, $, _, Z, c, b as b2, V, U, S, Y, X, g, d, e, a as a2, f, ai, ah, O, N, P as P2, x, W, t, m, u, r, q, p, ag, v, ak, aj, a5, a3, a4, a2 as a22 } from "./update-air-luggage-journeys-DAg_1mM1.js";
import { z as z2 } from "zod";
const triggerAirPayoutJourneyRequestSchema = z2.object({
  journeyId: z2.number(),
  token: z2.string(),
  payload: journeySchema
});
const triggerAirPayoutJourneyResponseSchema = journeySchema;
function triggerAirPayoutJourney({
  client,
  params
}) {
  const { journeyId, payload, token } = triggerAirPayoutJourneyRequestSchema.parse(params);
  return client.url(`/api/v2/air_bundle/journeys/${journeyId}/air_payout_journeys/payout`).query({ token }).post(triggerAirPayoutJourneyRequestSchema.parse(payload)).valid(triggerAirPayoutJourneyResponseSchema);
}
const postDashboardVisitedResponseSchema = z2.object({});
function postDashboardVisited({ client }) {
  return client.url("/api/v2/user_profiles/dashboard_visited").patch({}).valid(postDashboardVisitedResponseSchema);
}
const postPersonalDetailsProvidedResponseSchema = z2.object({});
function postPersonalDetailsProvided({ client }) {
  return client.url("/api/v2/user_profiles/personal_details_provided").patch({}).valid(postPersonalDetailsProvidedResponseSchema);
}
const validateActivationTokenResponseSchema = z2.object({
  activationStatus: z2.enum(["active", "inactive"]),
  email: z2.string(),
  resetPasswordToken: z2.string()
});
const validateActivationTokenRequestSchema = z2.object({
  tripUuid: z2.string(),
  token: z2.string()
});
function validateActivationToken({
  client,
  params
}) {
  const { tripUuid, token } = validateActivationTokenRequestSchema.parse(params);
  return client.url(`/api/v2/trips/${tripUuid}/validate_activation_token`).post({ token }).valid(validateActivationTokenResponseSchema);
}
const activateTripRequestSchema = z2.object({
  tripUuid: z2.string(),
  token: z2.string()
});
function activateTrip({
  client,
  params
}) {
  const { tripUuid, token } = activateTripRequestSchema.parse(params);
  return client.url(`/api/v2/trips/${tripUuid}/activate`).post({ token });
}
function createBaseAhPlusHTTPClient({
  caller: caller$1,
  baseURL,
  options
}) {
  return createHTTPClient({
    baseURL,
    options: {
      credentials: "include",
      ...options
    }
  }).addon(caller).addon(valid()).addon(queryStringAddon).addon(snakeCaseBody()).caller(caller$1);
}
export {
  A as AirBundleRejectionReason,
  H as AirLuggageStatus,
  B as AirPayoutCoverage,
  z as AirPayoutDisruption,
  y as AirPayoutStatus,
  Q as BANK_INPUTS,
  C as CheckDeletableReasons,
  a as PAYMENT_FREQUENCY,
  P as PRODUCT_NAME,
  b as PRODUCT_PERK,
  T as TripTier,
  activateTrip,
  activateTripRequestSchema,
  ac as addJourney,
  ab as addJourneyResponseSchema,
  I as airLuggageJourneysSchema,
  J as airLuggagesUpateRequestSchema,
  D as airPayoutJourneysSchema,
  E as airPayoutPaymentPaxSchema,
  F as airPayoutRequestSchema,
  G as airPayoutsUpateRequestSchema,
  w as airRejections,
  M as airlineSchema,
  L as airportSchema,
  R as bankFieldsSchema,
  af as cancelMembership,
  ae as cancelMembershipResponseSchema,
  ad as cancelMembershipSchema,
  createBaseAhPlusHTTPClient,
  a1 as deleteJourney,
  a0 as deleteJourneySchema,
  a7 as editableFellowPassengerSchema,
  a6 as editableFlightSchema,
  a8 as editableItinerarySchema,
  aa as editableJourneyRequestSchema,
  a9 as editableJourneySchema,
  s as featureFlagSchema,
  K as fellowPassengerSchema,
  o as fetchAirLuggageJourneys,
  n as fetchAirLuggageJourneysResponseSchema,
  l as fetchAirLuggageJourneysSchema,
  k as fetchAirPayoutJourneys,
  i as fetchAirPayoutJourneysResponseSchema,
  h as fetchAirPayoutJourneysSchema,
  $ as fetchCheckDeletableJourney,
  _ as fetchCheckDeletableJourneyResponseSchema,
  Z as fetchCheckDeletableJourneySchema,
  c as fetchFeatureFlags,
  b2 as fetchFeatureFlagsResponseSchema,
  V as fetchJourney,
  U as fetchJourneyResponseSchema,
  S as fetchJourneySchema,
  Y as fetchJourneys,
  X as fetchJourneysResponseSchema,
  g as fetchLounges,
  d as fetchLoungesRequestSchema,
  e as fetchLoungesResponseSchema,
  a2 as fetchOffers,
  f as fetchOffersResponseSchema,
  ai as fetchTrip,
  ah as fetchTripRequestSchema,
  O as flightSchema,
  N as flightStatusSchema,
  P2 as itinerarySchema,
  x as journeyCheckDeletableSchema,
  journeySchema,
  W as journeyWithMetaSchema,
  t as loungeSchema,
  m as makeFetchOffersRoute,
  u as offerSchema,
  postDashboardVisited,
  postDashboardVisitedResponseSchema,
  postPersonalDetailsProvided,
  postPersonalDetailsProvidedResponseSchema,
  r as postPromoCode,
  q as postPromoCodeResponseSchema,
  p as postPromoCodeSchema,
  triggerAirPayoutJourney,
  triggerAirPayoutJourneyRequestSchema,
  triggerAirPayoutJourneyResponseSchema,
  ag as tripResponseSchema,
  v as tripSchema,
  ak as updateAirLuggageJourneys,
  aj as updateAirPayoutJourneys,
  a5 as updateJourney,
  a3 as updateJourneyRequestSchema,
  a4 as updateJourneyResponseSchema,
  a22 as updateJourneySchema,
  validateActivationToken,
  validateActivationTokenRequestSchema,
  validateActivationTokenResponseSchema
};
//# sourceMappingURL=index.js.map
